export interface ErrorMessage {
  message: string;
  status?: number;
}

export interface IAuthState {
  mobileNumber?: string;
  otpToken?: string;
  showOTPScreen?: boolean;
  getOTPSuccess?: any;
  getOTPError: any;
  verifyOTPSuccess?: any;
  verifyOTPError?: any;
  isLoading: boolean;
  globalError?: ErrorMessage;
}

export const initialState: IAuthState = {
  mobileNumber: atob(localStorage.getItem('pno') || ''),
  otpToken: '',
  showOTPScreen: false,
  getOTPSuccess: {},
  getOTPError: {},
  verifyOTPSuccess: {},
  verifyOTPError: null,
  isLoading: false
};

export const LoginInputScreenConstants = {
  title: 'Log into Longhorn',
  subTitle: 'Use your Navi google employee account',
  inputPlaceholder: 'Enter mobile number',
  btnTextSendOTP: 'Log in via OTP',
  btnTextSendingOTP: 'Sending OTP',
  btnTextSignInWithGoogle: 'Log in with Google',
  btnTextSigningIn: 'Logging in...',
  otpSubtitle: 'Use your registered mobile number'
};

export const OTPInputScreenConstants = {
  title: 'Enter OTP',
  subTitle: 'OTP sent to',
  changeButtonText: 'Change',
  OTPMessageBeforeTimeout: 'Resend OTP in ',
  ResendOTP: 'Resend OTP',
  OTPMessageOnInput: 'Enter 4 digits OTP or',
  InvalidOTP: 'Invalid OTP, Try again or',
  VerifyOTP: 'Verify OTP',
  VerifyingOTP: 'Verifying OTP',
  errorMessage: 'OTP could not be sent, some error occurred',
  successMessage: 'OTP sent successfully'
};

export const OTP_RESEND_TIME_OUT = 30000;

export enum Roles {
  ROLE_SKIP_TRACING = 'ROLE_SKIP_TRACING',
  ROLE_FIELD_AGENT = 'ROLE_FIELD_AGENT',
  ROLE_CALLING_AGENT = 'ROLE_CALLING_AGENT',
  ROLE_HUMAN_REMINDER_AGENT = 'ROLE_HUMAN_REMINDER_AGENT',
  ROLE_HUMAN_REMINDER_SPADE_CALLING_AGENT = 'ROLE_HUMAN_REMINDER_SPADE_CALLING_AGENT',
  ROLE_NAVI_FIELD_EXTERNAL_TEAM_LEAD = 'ROLE_NAVI_FIELD_EXTERNAL_TEAM_LEAD',
  ROLE_NAVI_FIELD_TEAM_LEAD = 'ROLE_NAVI_FIELD_TEAM_LEAD',
  ROLE_SENIOR_TEAM_LEAD = 'ROLE_SENIOR_TEAM_LEAD',
  ROLE_TEAM_LEAD = 'ROLE_TEAM_LEAD',
  ROLE_INHOUSE_PERSONNEL = 'ROLE_INHOUSE_PERSONNEL',
  ROLE_ALLOCATIONS_ACCESS = 'ROLE_ALLOCATIONS_ACCESS',
  ROLE_TELE_ALLOCATIONS_ACCESS = 'ROLE_TELE_ALLOCATIONS_ACCESS',
  ROLE_COLLECTION_HEAD = 'ROLE_COLLECTION_HEAD',
  NAVI_INHOUSE_FIELD_CLUSTER_MANAGER = 'NAVI_INHOUSE_FIELD_CLUSTER_MANAGER',
  NAVI_INHOUSE_FIELD_ZONAL_MANAGER = 'ROLE_NAVI_INHOUSE_FIELD_ZONAL_MANAGER',
  ROLE_NAVI_FIELD_AGENCY_TEAM_LEAD = 'ROLE_NAVI_FIELD_AGENCY_TEAM_LEAD',
  ROLE_HUMAN_REMINDER_TEAM_LEAD = 'ROLE_HUMAN_REMINDER_TEAM_LEAD',
  ROLE_HUMAN_REMINDER_CHAT_AGENT = 'ROLE_HUMAN_REMINDER_CHAT_AGENT',
  ROLE_TELE_CHAT_AGENT = 'ROLE_TELE_CHAT_AGENT',
  ROLE_NAVI_TELE_INHOUSE_TEAM_LEAD = 'ROLE_NAVI_TELE_INHOUSE_TEAM_LEAD',
  ROLE_DIGITAL_AGENT = 'ROLE_DIGITAL_AGENT',
  ROLE_DEBUG_READ = 'ROLE_DEBUG_READ',
  ROLE_NAVI_TELE_FIELD_TEAM_LEAD = 'ROLE_NAVI_TELE_FIELD_TEAM_LEAD',
  ROLE_NAVI_30_PLUS_CALLING_TEAM_LEAD = 'ROLE_NAVI_30_PLUS_CALLING_TEAM_LEAD',
  ROLE_NAVI_16_30_FIELD_TEAM_LEAD = 'ROLE_NAVI_16_30_FIELD_TEAM_LEAD',
  ROLE_NAVI_16_30_FIELD_AGENCY_MANAGER = 'ROLE_NAVI_16_30_FIELD_AGENCY_MANAGER',
  ROLE_USER_MANAGEMENT_ADMIN = 'ROLE_USER_MANAGEMENT_ADMIN',
  ROLE_NAVI_INHOUSE_FIELD_ZONAL_MANAGER = 'ROLE_NAVI_INHOUSE_FIELD_ZONAL_MANAGER',
  ROLE_NAVI_EXTERNAL_FIELD_COLLECTION_HEAD = 'ROLE_NAVI_EXTERNAL_FIELD_COLLECTION_HEAD',
  ROLE_TELE_LITE_AGENT = 'ROLE_TELE_LITE_AGENT',
  ROLE_COLLECTION_CONFIG_READ = 'ROLE_COLLECTION_CONFIG_READ',
  ROLE_COLLECTION_CONFIG_WRITE = 'ROLE_COLLECTION_CONFIG_WRITE',
  ROLE_GLOBAL_ACCESS = 'ROLE_GLOBAL_ACCESS',
  ROLE_BANK_STATEMENT_ACCESS = 'ROLE_BANK_STATEMENT_ACCESS',
  ROLE_IN_HOUSE_CSA_AGENT = 'ROLE_INHOUSE_CSA',
  ROLE_EXTERNAL_CSA = 'ROLE_EXTERNAL_CSA',
  ROLE_COLLECTION_EFFORTS_PAUSE_ACCESS = 'ROLE_COLLECTION_EFFORTS_PAUSE_ACCESS',
  ROLE_TECH_EXCLUSIVE_ACCESS = 'ROLE_TECH_EXCLUSIVE_ACCESS',
  ROLE_NUMBER_MANAGEMENT = 'ROLE_NUMBER_MANAGEMENT',
  ROLE_CENTRAL_UNIT = 'ROLE_CENTRAL_UNIT',
  ROLE_NAVI_EXTERNAL_FIELD_ZONAL_MANAGER = 'ROLE_NAVI_EXTERNAL_FIELD_ZONAL_MANAGER',
  ROLE_NAVI_REPORTS_CONFIGURATION = 'ROLE_NAVI_REPORTS_CONFIGURATION',
  ROLE_ALLOCATION_EXPERIMENT = 'ROLE_ALLOCATION_EXPERIMENT',
  ROLE_NAVI_EXTERNAL_FIELD_REGIONAL_MANAGER = 'ROLE_NAVI_EXTERNAL_FIELD_REGIONAL_MANAGER',
  ROLE_NAVI_EXTERNAL_FIELD_AGENCY_MANAGER = 'ROLE_NAVI_EXTERNAL_FIELD_AGENCY_MANAGER',
  ROLE_OMA = 'ROLE_OMA',
  ROLE_PX_AUDIT_AGENT = 'ROLE_PX_AUDIT_AGENT',
  ROLE_PX_AUDIT_TEAM_LEAD = 'ROLE_PX_AUDIT_TEAM_LEAD'
}

export const agentStateAndLanguageEditRoles = [
  Roles.NAVI_INHOUSE_FIELD_CLUSTER_MANAGER,
  Roles.NAVI_INHOUSE_FIELD_ZONAL_MANAGER,
  Roles.ROLE_NAVI_FIELD_EXTERNAL_TEAM_LEAD,
  Roles.ROLE_SENIOR_TEAM_LEAD,
  Roles.ROLE_COLLECTION_HEAD,
  Roles.ROLE_NAVI_EXTERNAL_FIELD_COLLECTION_HEAD,
  Roles.ROLE_USER_MANAGEMENT_ADMIN
];

export const agentCenterMandatoryRoles = [
  Roles.ROLE_CALLING_AGENT,
  Roles.ROLE_TELE_CHAT_AGENT,
  Roles.ROLE_TELE_LITE_AGENT
];

export const emailMandatoryRoles = [Roles.ROLE_SENIOR_TEAM_LEAD, Roles.ROLE_TEAM_LEAD];

export const permissionScreenConstants = {
  title: 'To continue, please enable notifications',
  instructions: 'Follow below instructions to enable notifications'
};

export const LONGHORN_SESSION_TOKEN = 'LONGHORN_SESSION_TOKEN';
export const WA_EXTENSION_ID = 'WA_EXTENSION_ID';
export const CODE_VERIFIER = 'CODE_VERIFIER';
export const WA_PLUGIN_VERSION = 'EXTENSION_VERSION';

export interface IMsClarityData {
  referenceId: string;
  phoneNumber: string;
  email: string;
}

export interface SendOTPPayload {
  phoneNumber: string;
}

export interface VerifyOTPPayload {
  otp: string;
  otpToken: string | undefined;
  source: string;
  deviceId: string | null;
  phoneNumber: string | undefined;
  captchaVerified?: boolean | false;
  fcmToken: string;
}
